var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16732 8.16663C7.70708 8.16663 7.33398 8.53972 7.33398 8.99996C7.33398 9.4602 7.70708 9.83329 8.16732 9.83329H19.834C20.2942 9.83329 20.6673 9.4602 20.6673 8.99996C20.6673 8.53972 20.2942 8.16663 19.834 8.16663H8.16732ZM8.16732 14.8333C7.70708 14.8333 7.33398 15.2064 7.33398 15.6666C7.33398 16.1269 7.70708 16.5 8.16732 16.5H19.834C20.2942 16.5 20.6673 16.1269 20.6673 15.6666C20.6673 15.2064 20.2942 14.8333 19.834 14.8333H8.16732Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16732 11.5C7.70708 11.5 7.33398 11.8731 7.33398 12.3333C7.33398 12.7936 7.70708 13.1667 8.16732 13.1667H19.834C20.2942 13.1667 20.6673 12.7936 20.6673 12.3333C20.6673 11.8731 20.2942 11.5 19.834 11.5H8.16732ZM8.16732 18.1667C7.70708 18.1667 7.33398 18.5398 7.33398 19C7.33398 19.4602 7.70708 19.8333 8.16732 19.8333H19.834C20.2942 19.8333 20.6673 19.4602 20.6673 19C20.6673 18.5398 20.2942 18.1667 19.834 18.1667H8.16732Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.cb1d7fde97d68797b56800e7e36345ed.svg";
export { ForwardRef as ReactComponent };